const MyCustomToast = ({ appearance, children }: {
  appearance: string,
  children: any,
}) => (
  <div className={`toast ${appearance}`}>
    {children}
  </div>
);

export default MyCustomToast;
